module.exports = __webpack_public_path__ + "img/drag-queen.00a5bddc.jpg";